<template>
    <v-form>
        <div class="reset-password__title">
            {{loginConstants.PASSWORD_RESET_TITLE}}
        </div>
        <div class="reset-password__name" v-if="!codeSent">
            {{recoveryData.FirstName}},
        </div>
        <div class="reset-password__reset-title" v-if="!codeSent">
            {{loginConstants.WHERE_TO_SEND_PASSWORD_RESET_CODE}}
        </div>
        <v-radio-group
                v-if="!codeSent"
                v-model="radioValue"
                color="primary"
                mandatory
                required>
            <v-layout justify-space-around column>
                <div class="reset-password__options">
                    <div class="reset-password__options-icon"><v-icon color="ypo_blue" large>mail_outline</v-icon></div>
                    <v-radio
                            class="reset-password__options-radio"
                            v-if="recoveryData.email"
                            :label="recoveryData.email"
                            value="email"
                    ></v-radio>
                </div>
                <div class="reset-password__options">
                    <div class="reset-password__options-icon"><v-icon color="ypo_blue" large>phone_android</v-icon></div>
                    <v-radio
                            class="reset-password__options-radio"
                            v-if="recoveryData.recoveryPhoneNumber"
                            :label="recoveryData.recoveryPhoneNumber"
                            value="sms"
                    ></v-radio>
                </div>
            </v-layout>
        </v-radio-group>
        <v-flex v-if="codeSent && !isSubmitting">
            <div class="recovery-code-success">
                <div class="recovery-code-success__message">{{loginConstants.RECOVERY_CODE_SUCCESS}}</div>
                <div class="recovery-code-success__media">
                    {{selectedRecoveryType}}
                </div>
            </div>
            <v-btn
                    id="resend_recovery_btn"
                    data-qe-id="resend_recovery_btn"
                    @click="submit"
                    :disabled="isSubmitting"
                    color="ypo_blue"
                    flat
            >
                <v-icon color="ypo_blue_secondary" left>replay</v-icon>
                {{loginConstants.RESEND_CODE}}
            </v-btn>
        </v-flex>
        <login-error></login-error>
        <v-card-actions>
            <v-layout row pt-3>
                <v-btn
                        v-if="!codeSent"
                        id="submit_reset_code_btn"
                        data-qe-id="submit_reset_code_btn"
                        color="ypo_blue"
                        dark
                        @click="submit"
                        :disabled="isSubmitting"
                        large
                        block
                >
                    {{loginConstants.SUBMIT}}
                </v-btn>
                <v-btn
                        v-if="codeSent"
                        id="enter_reset_code_btn"
                        data-qe-id="enter_reset_code_btn"
                        color="ypo_blue"
                        dark
                        @click="changeCardState(loginConstants.componentNames.recoveryCodeForm.component);"
                        :disabled="isSubmitting"
                        large
                        block
                >
                    {{loginConstants.ENTER_CODE}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from "../LoginError";

    export default {
        name: 'RecoveryOptions',
        components: { LoginError },
        data: () => ({
            loginConstants,
            radioValue: '',
            codeSent: false,
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        methods: {
            ...mapActions({
                submitPasswordRecoveryOption: `auth/${storeAction.submitPasswordRecoveryOption}`,
            }),
            submit() {
                this.toggleProgressIndicator();
                this.submitPasswordRecoveryOption(this.radioValue)
                    .then(() => {
                        this.toggleProgressIndicator();
                        this.codeSent = true;
                    })
                    .catch(() => {
                        //TODO: handle error
                        this.toggleProgressIndicator();
                        this.codeSent = false;
                    });
            },
        },
        computed: {
            ...mapGetters({
                recoveryData: `auth/${storeGetters.passwordRecoveryOptions}`,
            }),
            selectedRecoveryType() {
                if (this.radioValue) {
                    return this.radioValue === this.loginConstants.recoveryValues.email
                        ? this.recoveryData.Email
                        : this.recoveryData.RecoveryPhoneNumber;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .reset-password {
        &__title {
            padding: 5px 10px 20px;
            text-align: center;
            font-size: 23px;
            color: $ypo-blue;
        }

        &__name {
            font-size: 20px;
            color: $ypo-blue;
            text-align: center;
            padding-bottom: 5px;
        }

        &__reset-title {
            font-size: 16px;
            color: $ypo-blue;
            text-align: center;
        }

        &__options {
            display: flex;
            justify-content: center;
            flex-direction: row;
            padding: 10px 2px;

            &-icon {
                flex-basis: 40%;
                padding-right: 10px;
                text-align: right;
            }
            &-radio {
                flex-basis: 50%;
            }
        }
    }

    #submit_reset_code_btn {
        .v-btn__content {
            color: $white;
        }
    }

    .recovery-code-success {
        padding: 5px 20px;

        &__message {
            color: $ypo_blue;
        }

        &__media {
            color: $ypo_gold;
        }
    }
</style>
